import { defineComponent as _defineComponent } from 'vue'
import {defineComponent} from 'vue';
import {useHouseholds} from '@/components/calculator/form/useSimulationForm';
import MultiformListManager from '@/modules/multiForm/views/MultiformListManager.vue';
import SimulationFormStep3Wrapper from '@/components/calculator/form/SimulationFormStep3Wrapper.vue';
import {FFBorrower} from '@/models/ExpertState';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';

export default /*#__PURE__*/_defineComponent({
  __name: 'CashSimulationFormStep3',
  setup(__props) {

const {households,} = useHouseholds();


return { __sfc: true,households, MultiformListManager, SimulationFormStep3Wrapper, I18NGetter }
}

})